export const ButtonSpinner = () => <span className="button-spinner" aria-hidden="true" />;
